import { createContext } from "react";

const providerContext = createContext()

export default providerContext